export default {
  index: [
    {
      path: '/bxdj',
      component: resolve => require(['./expensereimburseIndex.vue'], resolve),
    }
  ]
}



// WEBPACK FOOTER //
// ./src/view/bxdengji/_router.js